import { decl, bool2string } from '@yandex-lego/i-bem-react';
export default decl({
  block: 'header2',
  elem: 'paranja',
  willInit: function willInit() {
    this._onScroll = this._onScroll.bind(this);
  },
  willReceiveProps: function willReceiveProps(_ref) {
    var active = _ref.active;

    if (active) {
      window.addEventListener('scroll', this._onScroll);
    } else {
      window.removeEventListener('scroll', this._onScroll);
    }
  },
  attrs: function attrs(_ref2) {
    var onClick = _ref2.onClick;
    return {
      onClick: onClick
    };
  },
  mods: function mods(_ref3) {
    var active = _ref3.active;
    return {
      active: bool2string(active)
    };
  },
  _onScroll: function _onScroll() {
    this.props.onScroll && this.props.onScroll();
  }
});